import React, { useState } from "react";
import { CopyIcon } from "./SVGIcons";
import clsx from "clsx";
import { useTheme } from "../context/ThemeContext";

const CopyBtn = ({ content, className }: { content: string, className?: string }) => {
    const [copied, setCopied] = useState(false);
    const { isDark } = useTheme();
    const handleCopyAddress = async () => {
        try {
            await navigator.clipboard.writeText(content);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy address:', err);
        }
    };

    return <button
        onClick={handleCopyAddress}
        className={clsx("hover:bg-gray-100 dark:hover:bg-gray-800 rounded transition-colors", className)}
        title="Copy address"
    >
        {copied ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
        ) : (
            <CopyIcon fillColor={isDark ? 'white' : 'black'} />
        )}
    </button>
};

export default CopyBtn;
